import * as React from 'react';
import { styled, useTheme, Theme, CSSObject } from '@mui/material/styles';
import Box from '@mui/material/Box';
import MuiDrawer from '@mui/material/Drawer';
import MuiAppBar, { AppBarProps as MuiAppBarProps } from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import axiomOpen from '../../images/axiomOpen.svg';
import axiomIcon from '../../images/axiomIcon.svg'
import PestControlIcon from '@mui/icons-material/PestControl';
import { Link } from "react-router-dom";
import './MainMenu.scss';
import  {useState} from 'react'
import Cookies from 'universal-cookie';
import cloudIcon from '../../images/cloud.svg';
import uploadIcon from '../../images/upload.svg';
import { DiRedis } from "react-icons/di";
import settingsIcon from '../../images/settings.svg'
import hamburgerIcon from '../../images/hamburger.svg'
import PermissionsGate from '../PermissionsGate/PermissionsGate'
import {SCOPES} from '../PermissionsGate/permissionMaps'
import Button from '../Button/Button';
const drawerWidth = 240;

const openedMixin = (theme: Theme): CSSObject => ({
  width: drawerWidth,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
});

const closedMixin = (theme: Theme): CSSObject => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});
const cookies = new Cookies();
const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

interface AppBarProps extends MuiAppBarProps {
  open?: boolean;
}

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})<AppBarProps>(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',
    ...(open && {
      ...openedMixin(theme),
      '& .MuiDrawer-paper': openedMixin(theme),
    }),
    ...(!open && {
      ...closedMixin(theme),
      '& .MuiDrawer-paper': closedMixin(theme),
    }),
  }),
);

function logout(){
  cookies.remove("google_login");
  cookies.remove("github_login");
  cookies.remove("google_code");
  cookies.remove("code");
  window.location.replace(process.env.REACT_APP_DOMAIN+"/login");
}

export default function MiniDrawer() {

  let menuConfig;
    menuConfig=  [
      {
        name: 'Create new env',
        link: '/createEnv',
        iconName: <img src={cloudIcon}/>,
        permission: SCOPES.canEdit
      },
      {
        name: 'Debugger',
        link: '/debugger',
        iconName: <PestControlIcon/>,
        permission: SCOPES.canEdit
      },
      // {
      //   name: 'Search IP',
      //   link: '/ip',
      //   iconName:<LocationOnIcon/>
      // },
      {
        name: 'Releases',
        link: '/releases',
        iconName:<img src={uploadIcon}/>,
        permission: SCOPES.canView
      },
      {
        name: 'Services',
        link: '/services',
        iconName:<img src={settingsIcon}/>,
        permission: SCOPES.canEdit
      },
      {
        name: 'Redis',
        link: '/redis',
        iconName: <DiRedis size={36} />        ,
        permission: SCOPES.canEdit
      },
      {
        name: 'Audits',
        link: '/audits',
        iconName:<img src={hamburgerIcon}/>,
        permission: SCOPES.canEdit
      },
    ];


  const [activeIndex, setActiveIndex] = useState(0);

  const theme = useTheme();
  const [open, setOpen] = React.useState(false);

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  return (
    <Box sx={{ display: 'flex' }}>
      
      <CssBaseline />
      
      <AppBar position="fixed" open={open}>
     
        <Toolbar>
        
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            sx={{
              marginRight: 5,
              ...(open && { display: 'none' }),
            }}
          >
            <MenuIcon />
          </IconButton>
          <p id="user_name"> Hello {cookies.get("name")} </p>
          <Button text="LOGOUT" className="logout" onClick={()=>logout() }/>
        </Toolbar>
      </AppBar>
      <Drawer variant="permanent" open={open}>
        <DrawerHeader>
          <IconButton onClick={handleDrawerClose}>
            {theme.direction === 'rtl' ? <ChevronRightIcon /> : <ChevronLeftIcon />}
          </IconButton>
        </DrawerHeader>
        <Divider />
        {open? (
          <img src={axiomOpen} alt="Workiz logo" id="workiz_logo"  />

        ):(
          <img src={axiomIcon} alt="Workiz logo" id="w_logo" />

        )}
        
        <List>
     
          {menuConfig && menuConfig.map((menuItem,index) => (
            <PermissionsGate scopes={[menuItem.permission]} key={index}>
             <Link to={`${menuItem.link}`} style={{ textDecoration: 'none' , color: "black"}} key={menuItem.name} onClick={()=>setActiveIndex(index)}>
              <ListItem key={menuItem.name} disablePadding sx={{ display: 'block'}} style={{ backgroundColor: activeIndex==index ? '#D3D3D3' : 'white' , borderLeft: activeIndex==index ? "4px solid #15B097" :""}} button>
              
                <ListItemButton
                  sx={{
                    minHeight: 48,
                    justifyContent: open ? 'initial' : 'center',
                    px: 2.5,
                  }}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: open ? 3 : 'auto',
                      justifyContent: 'center',
                    }}
                  >
                {menuItem.iconName} 
                  </ListItemIcon>
                  <ListItemText primary={menuItem.name} sx={{ opacity: open ? 1 : 0 }} />
                </ListItemButton>
              </ListItem>
            </Link>
            </PermissionsGate>
          ))}
        </List>
        <Divider />
        <List>
        </List>
      </Drawer>
      <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
        <DrawerHeader />
      </Box>
    </Box>
  );
}
